module.exports = __webpack_public_path__ + "static/media/check-white.9589f6b8.svg";